<template>
  <a class="v3-h6-regular-400-line-height-1.5 text-[var(--v3-theme-highlighttextcolor)]" :href="link" data-metatip="true">{{ label }}</a>
</template>
  
<script setup lang='ts'>
defineProps<{
  link: string;
  label: string
}>();
</script>
  
